import { gql } from '@apollo/client';

export const UpdateOneFile = gql`
mutation UpdateOneFile($fileId: Int!, $file: String, $name: String, $type: String) {
  updateOneFile(fileId: $fileId, file: $file, name: $name, type: $type) {
    id
  }
}`;

export const ReuseFilesFromPreviousSeason = gql`
mutation ReuseFilesFromPreviousSeason($profileId: Int!, $fileIds: [Int!]!) {
  reuseFilesFromPreviousSeason(profileId: $profileId, fileIds: $fileIds)
}`;
